import { toast } from "sonner";
import { z } from "zod";

import { BaseForm, FormRecordPicker } from "components/BaseForm";
import { useTagMutations } from "hooks/useTagManagementTable";
import TagCategoryService from "services/TagCategory";

const schema = z.object({
  tag_category_id: z.number().nullable(),
});

const fetchCategories = search =>
  TagCategoryService.getTagCategoryForFilters(
    search ? { search_query: search } : null
  );

const BulkUpdateCategoryForm = ({ tagIds, onSuccess, onCancel }) => {
  const { bulkUpdateCategory } = useTagMutations();

  const handleSubmit = async ({ tag_category_id }) => {
    await bulkUpdateCategory.mutateAsync({
      categoryId: tag_category_id,
      tagIds,
    });
  };

  const handleSuccess = () => {
    toast.success("Category updated");
    onSuccess();
  };

  return (
    <BaseForm
      schema={schema}
      defaultValues={{ tag_category_id: null }}
      onSubmit={handleSubmit}
      onSuccess={handleSuccess}
      onCancel={onCancel}
      submitButtonText="Update"
    >
      <FormRecordPicker
        name="tag_category_id"
        label="Tag Category"
        fetchOptions={fetchCategories}
        onCreate={label =>
          TagCategoryService.createTagCategory({ name: label })
        }
      />
    </BaseForm>
  );
};

export default BulkUpdateCategoryForm;
